function getCachedLocation() {
    let geo = localStorage.getItem("geo_location");
    if(!geo)
        return false;

    geo = JSON.parse(geo);
    const now = (new Date()).getTime();
    if(geo === false || now - geo.updated_at >= 600000)//10 mins
        return false;

    return geo.location;
}

function setCachedLocation(lat, lng) {
    const geo = {
        location:{lat:lat, lng:lng},
        updated_at:(new Date()).getTime(),
    };
    localStorage.setItem("geo_location", JSON.stringify(geo));
    return geo.location;
}

function getLocation(commit) {
    return new Promise((resolve, reject) => {
        wx.ready(function () {
            wx.getLocation({
                type: 'gcj02',
                success: function (res) {
                    setCachedLocation(res.latitude, res.longitude);
                    commit('update',{lat:res.latitude, lng:res.longitude});
                    resolve({lat:res.latitude, lng:res.longitude});
                },
                fail: function (res) {
                    reject();
                },
            });
        });
    })

}

export default {
    namespaced: true,
    state:{
        lat:null, lng:null, dataState:'none'
    },
    getters:{

    },
    actions:{
        init({commit, state}) {
            return new Promise((resolve, reject) => {
                console.log(state.dataState);
                const cachedLocation = getCachedLocation();
                if(cachedLocation === false) {
                    if(state.dataState != 'none')
                        return;

                    console.log('refresh geo location');
                    commit('updateState','loading');
                    // setTimeout(()=> {
                    //     setCachedLocation(31.657420, 104.065840);
                    //     commit('update',{lat:31.657420, lng:104.065840});
                    //     resolve()
                    // }, 3000);
                    //return ;
                    getLocation(commit)
                        .then(res => {
                            resolve()
                        })
                        .catch(err => {
                            return reject();
                        })
                } else {
                    console.log('geo location from cache');
                    commit('update',cachedLocation);
                    return resolve()
                }
            })


        }
    },
    mutations:{
        update(state,data){
            state.dataState = 'loaded';
            state.lat = data.lat;
            state.lng = data.lng;
        },
        updateState(state, data) {
            state.dataState = data;
        },
    }
}